module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subheader clearfix"
  }, [_c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('patient')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.patientContext,
    attrs: {
      "src": require("assets/images/Patient_Text.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('practice')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.practiceContext,
    attrs: {
      "src": require("assets/images/Practice_Text.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "col-xs-4",
    on: {
      "click": function($event) {
        return _vm.updateContext('academic')
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    class: _vm.academicContext,
    attrs: {
      "src": require("assets/images/Academic_Text.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b9d840"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ContextSelector.vue
// module id = 645
// module chunks = 5